import { action, observable } from 'mobx';

export class NavigationState {
    @observable shouldToggleNavigation: boolean = false;
    @action
    setNavigationToggle(value: boolean) {
        this.shouldToggleNavigation = value;
    }
}
